import { FC, useEffect } from 'react';
import { ThemeModalState } from '../../themes-grid/model/types';
import { ThemeEditModalForm } from './ThemeEditModalForm';
import { ThemeEditModalHeader } from './ThemeEditModalHeader';

interface Props {
	openModal: ThemeModalState;
	handleModalClose: () => void;
	setShowErrorToast: (state: boolean) => void;
}

const ThemeEditModal: FC<Props> = ({
	openModal,
	handleModalClose,
	setShowErrorToast,
}) => {
	useEffect(() => {
		document.body.classList.add('modal-open');
		return () => {
			document.body.classList.remove('modal-open');
		};
	}, []);

	return (
		<>
			<div
				className='modal fade show d-block'
				id='kt_modal_theme'
				role='dialog'
				tabIndex={-1}
				aria-modal='true'
			>
				<div className='modal-dialog modal-dialog-centered mw-650px'>
					<div className='modal-content'>
						<ThemeEditModalHeader
							openModal={openModal}
							handleModalClose={handleModalClose}
						/>
						<div className='modal-body scroll-y mx-5 mx-xl-15 my-7'>
							<ThemeEditModalForm
								openModal={openModal}
								handleModalClose={handleModalClose}
								setShowErrorToast={setShowErrorToast}
							/>
						</div>
					</div>
				</div>
			</div>
			<div className='modal-backdrop fade show' onClick={handleModalClose} />
		</>
	);
};

export { ThemeEditModal };
